// extracted by mini-css-extract-plugin
export var container = "cIk5rv+U";
export var items = "_2nzcZ6mV";
export var item = "QFrkQi6m";
export var icon = "H1hplVSQ";
export var mlh = "AnK3Km8v";
export var label = "jIP4rSad";